import React from 'react';
import { Link } from 'react-router-dom';
import {
  ModalHeader,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import { useToasts } from 'react-toast-notifications';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import {
  LOGO_LARGE_WHITE, FALLBACK_ICON, formatedCurrency, getDaysDiff, OFFER_STATUS, NUMERIC_VALUE, TIMELINE_CONSTANTS, truncateLongString, OFFER_TABS,
} from '../../../utils';

function RenderOfferDetail(props) {
  const {
    toggle, data, renderOffersButtons, activeTab,
  } = props;
  const { addToast } = useToasts();

  let offerStatus = '';
  if (data?.isArtistParticipation && data.status === '') {
    offerStatus = OFFER_STATUS.ARTIST_ACCEPTED;
  } else {
    offerStatus = data.status;
  }

  const renderExpiresinDays = (days, useCustomText, text) => {
    if (days === NUMERIC_VALUE.ZERO) return useCustomText ? text : TIMELINE_CONSTANTS.DUE_TODAY;
    if (days === NUMERIC_VALUE.ONE) return `in ${days} day`;
    return `in ${days} days`;
  };

  const copyToClipAction = () => {
    addToast('Copied', { appearance: 'success' });
  };

  return (
    <>
      <div className="offer-detail-modal-cover-wrapper">
        <div className="modal-cover">
          <img
            src={data.coverImage}
            alt="Offer Cover"
          />
        </div>
        <div className="modal-header-wrapper">
          <ModalHeader toggle={toggle} className="modal-blank-header" />
          <Link to="/dashboard" className="modal-offer-detail-logo">
            <ReactImageFallback
              src={LOGO_LARGE_WHITE}
              fallbackImage={FALLBACK_ICON}
              alt="BYGmusic"
            />
          </Link>
        </div>
      </div>
      <div className="modal-offer-detail-head">
        <div className="offer-detail-cover-detail">
          {
            !data?.isClientLogoHide
              ? (
                <div className="modal-offer-detail-head-image">
                  <ReactImageFallback
                    src={data.clientLogo}
                    fallbackImage={FALLBACK_ICON}
                    alt="BYGmusic"
                  />
                </div>
              )
              : (
                <div className="modal-offer-detail-head-image transparent-background border-0" />
              )
          }
          <span className="offer-name">{data.clientName}</span>
          <h2>{data.title}</h2>
          <h4>
            {data.description}
          </h4>
        </div>
        <div className="offer-detail-cover-card">
          <p>
            {(!!data.basePrice || !!data.participants?.basePrice)
              && (!data.status || [OFFER_STATUS.ARTIST_REQUESTED, OFFER_STATUS.ADMIN_ACCEPTED, OFFER_STATUS.ADMIN_REQUESTED, OFFER_STATUS.ARTIST_ACCEPTED].indexOf(data.status) > -1
                ? 'Offered for' : 'Accepted for')}
            <span>
              <em className="offer-base-price-text">
                {
                  (
                    (data.participants?.basePrice && data.participants?.basePrice !== NUMERIC_VALUE.ZERO)
                    || (data.basePrice && data.basePrice !== NUMERIC_VALUE.ZERO)
                  )
                    ? `$${formatedCurrency(data.participants?.basePrice || data.basePrice)}`
                    : (
                      <p className="flex-card-offer-text">
                        {!data.isContractAccepted
                          ? (
                            <>
                              <em
                                data-tip={data.basePriceText}
                                data-place="bottom"
                                data-background-color="#fff"
                                data-text-color="#000"
                              >
                                {truncateLongString(data.basePriceText, NUMERIC_VALUE.MAX_BASE_PRICE_TEXT_LIMIT_IN_DETAIL, false)}
                              </em>
                              <ReactTooltip effect="solid" />
                            </>
                          )
                          : <em>Gig Accepted</em>}
                      </p>
                    )
                }
              </em>
            </span>
          </p>
          {
            !data.isContractAccepted
            && data.status !== OFFER_STATUS.ADMIN_ACCEPTED
            && (
            <h3>
              <span className="icon-glass" />
              Offer expires
              {' '}
              {
                renderExpiresinDays(getDaysDiff(new Date(), activeTab === OFFER_TABS.MY_OFFERS ? data.offerMaxDate : data.endDeadline), true, 'today')
              }
            </h3>
            )
          }
          {renderOffersButtons(data, offerStatus)}
        </div>
      </div>
      <div className="scrolled-card-wrapper">
        <div className="scrolled-card-wrapper-container">
          <Link to="/dashboard" className="modal-offer-detail-logo">
            <ReactImageFallback
              src={LOGO_LARGE_WHITE}
              fallbackImage={FALLBACK_ICON}
              alt="BYGmusic"
            />
          </Link>
          <div className="scrolled-card-name">
            {
              !data?.isClientLogoHide
                ? (
                  <div className="img-wrapper">
                    <ReactImageFallback
                      src={data.clientLogo}
                      fallbackImage={FALLBACK_ICON}
                      alt="BYGmusic"
                    />
                  </div>
                )
                : (
                  <div className="img-wrapper transparent-background border-0" />
                )
            }
            <h2>{data.clientName}</h2>
          </div>
          <ModalHeader toggle={toggle} className="modal-blank-header" />
        </div>
      </div>
      {data.isContractAccepted ? (
        <div className="modal-offer-detail-title">
          <div className="share-offer-url">
            {data.participants && data.participants.vanityUrl
            && (
            <>
              <h4>
                <span>Share link - </span>
                {' '}
                {data.participants.vanityUrl}
              </h4>
              <CopyToClipboard text={data.participants.vanityUrl} onCopy={copyToClipAction}>
                <span className="copy-url-btn" />
              </CopyToClipboard>
            </>
            )}
          </div>
        </div>
      )
        : ''}
    </>
  );
}

RenderOfferDetail.propTypes = {
  data: PropTypes.shape({
    coverImage: PropTypes.string,
    clientLogo: PropTypes.string,
    offerMinDate: PropTypes.string,
    offerMaxDate: PropTypes.string,
    status: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    clientName: PropTypes.string,
    basePrice: PropTypes.number,
    isClientLogoHide: PropTypes.bool,
    isArtistParticipation: PropTypes.bool,
    isBetaPostApproval: PropTypes.bool,
    participants: {
      basePrice: PropTypes.number,
    },
    isContractAccepted: PropTypes.bool,
    basePriceText: PropTypes.string,
  }).isRequired,
  toggle: PropTypes.func.isRequired,
  renderOffersButtons: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
};

export default RenderOfferDetail;
